import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroCarousel from './components/HeroCarousel';
import CategoryNav from './components/CategoryNav';
import HotRanking from './components/HotRanking';
import LatestUpdates from './components/LatestUpdates';
import FeaturedRecommend from './components/FeaturedRecommend';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroCarousel />
        <CategoryNav />
        <HotRanking />
        <LatestUpdates />
        <FeaturedRecommend />
        <FAQSection />
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '西瓜影院',
          url: 'https://www.xiguayingyuan.com/',
          description: '西瓜影院提供海量免费电影、电视剧、综艺在线观看，无需下载、无需付费、无需等待缓冲，高清画质流畅播放。',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://www.xiguayingyuan.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '西瓜影院',
          url: 'https://www.xiguayingyuan.com/',
          description: '西瓜影院 - 在线免费高清电影电视剧综艺平台',
          contactPoint: {
            '@type': 'ContactPoint',
            telephone: '+86-400-123-4567',
            contactType: 'customer service',
            areaServed: 'CN',
            availableLanguage: 'Chinese',
          },
        })}
      </script>
    </>
  );
}